import React from "react";
import styles from "./notificationTemplates.module.css";
import icon from "./message.svg";

const Inform = ({
  children,
  informIconProps = {
    size: 16,
  },
}) => {
  return (
    <div className={[styles.template, styles.Inform].join(" ")}>
      <img
        src={icon}
        alt="inform"
        {...informIconProps}
        width={informIconProps.size}
        height={informIconProps.size}
      />
      {children}
    </div>
  );
};
export default Inform;